
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 60 60\" id=\"icon-cctv\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M44.569,28.13L38.13,16.06c-0.25-0.49-0.859-0.67-1.35-0.41L16.14,26.64c-0.49,0.26-0.67,0.87-0.41,1.35\r\n\tl1.12,2.1l-4.21,2.241c-0.49,0.26-0.67,0.869-0.42,1.35l3.05,5.729c0.26,0.479,0.87,0.671,1.36,0.41l4.2-2.239l1.33,2.489\r\n\tc0.26,0.49,0.86,0.67,1.35,0.41l8.271-4.399l3.39,6.35l18.72,5.71C48.41,55.35,39.75,60,30,60C13.43,60,0,46.57,0,30\r\n\tC0,13.44,13.43,0,30,0c16.56,0,30,13.44,30,30c0,5.69-1.59,11.01-4.351,15.54l-18.42-5.609l-2.799-5.26l9.719-5.181\r\n\tC44.64,29.23,44.83,28.62,44.569,28.13z\"/> </symbol>";
module.exports = sprite.add(image, "icon-cctv");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/cctv.svg
 ** module id = 154
 ** module chunks = 24
 **/